export enum GenderType {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NA = 'NA',
  INTERSEXUAL = 'INTERSEXUAL'
}
